import React from 'react';
import { motion } from 'framer-motion';
import { Home, Building2, Wrench, AlertTriangle, Droplets, Waves } from 'lucide-react';
const services = [{
  title: 'Residential Plumbing',
  description: 'Complete plumbing solutions for your home, from minor leaks to full repiping.',
  icon: Home,
  // Bathroom faucet / fixture
  image: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?q=80&w=800&auto=format&fit=crop'
}, {
  title: 'Commercial Plumbing',
  description: 'Heavy-duty plumbing services tailored for businesses, restaurants, and facilities.',
  icon: Building2,
  // Industrial pipes / plumbing infrastructure
  image: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?q=80&w=800&auto=format&fit=crop'
}, {
  title: 'Repairs & Service',
  description: 'Expert diagnostics and lasting repairs for fixtures, pipes, and valves.',
  icon: Wrench,
  // Plumber wrench tools on pipe
  image: 'https://images.unsplash.com/photo-1542013936693-884638332954?q=80&w=800&auto=format&fit=crop'
}, {
  title: 'Emergency Plumbing',
  description: 'Available 24/7 for burst pipes, severe clogs, and urgent plumbing disasters.',
  icon: AlertTriangle,
  // Water leak / pipe issue
  image: 'https://images.unsplash.com/photo-1585074150328-65f7e6ddc1f6?q=80&w=800&auto=format&fit=crop'
}, {
  title: 'Water Heaters',
  description: 'Installation, repair, and maintenance for traditional and tankless systems.',
  icon: Droplets,
  // Copper pipes (water heater related)
  image: 'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?q=80&w=800&auto=format&fit=crop'
}, {
  title: 'Drain & Sewer',
  description: 'Professional drain cleaning, hydro-jetting, and sewer line inspections.',
  icon: Waves,
  // Drain / pipe interior
  image: 'https://images.unsplash.com/photo-1585675100529-1bcc55fc4d75?q=80&w=800&auto=format&fit=crop'
}];
export function Services() {
  return <section id="services" className="py-20 lg:py-28 bg-white" data-id="element-283">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-284">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-285">
          <h2 className="text-brand-red font-bold tracking-widest uppercase text-sm mb-3" data-id="element-286">
            Our Expertise
          </h2>
          <h3 className="text-4xl md:text-5xl font-display font-bold text-brand-navy uppercase mb-6" data-id="element-287">
            Comprehensive Plumbing Services
          </h3>
          <p className="text-gray-600 text-lg" data-id="element-288">
            No matter the size or complexity of the job, our licensed
            professionals have the experience and tools to get it done right the
            first time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-289">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group bg-white border border-gray-100 rounded-md shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 relative overflow-hidden flex flex-col" data-id="element-290">
              <div className="absolute top-0 left-0 w-full h-1 bg-brand-red transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out z-20" data-id="element-291"></div>

              <div className="h-48 w-full relative overflow-hidden bg-brand-navy" data-id="element-292">
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/40 to-transparent z-10" data-id="element-293"></div>
                <img src={service.image} alt={`${service.title} service`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-294" />
              </div>

              <div className="relative pt-10 pb-8 px-8 flex-grow flex flex-col" data-id="element-295">
                <div className="absolute -top-7 left-8 w-14 h-14 bg-brand-red rounded-md flex items-center justify-center text-white shadow-lg border-4 border-white" data-id="element-296">
                  <service.icon className="w-6 h-6" data-id="element-297" />
                </div>

                <h4 className="text-2xl font-display font-bold text-brand-navy uppercase mb-3" data-id="element-298">
                  {service.title}
                </h4>

                <p className="text-gray-600 mb-6 line-clamp-3 flex-grow" data-id="element-299">
                  {service.description}
                </p>

                <a href="#contact" className="inline-flex items-center text-brand-red font-bold uppercase tracking-wide text-sm group-hover:text-brand-redDark transition-colors mt-auto" data-id="element-300">
                  Learn more{' '}
                  <span className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-301">
                    →
                  </span>
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}